import { Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PlatformPeopleService } from '../../../../../Component/Api/PlatformPeople/PlatformPeopleService';
import { CoreStaticDataService } from '../../../../../Component/Api/StaticData/CoreStaticDataService';
import { IDropDownOptions } from '../../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { IntermediateGlobalLoading } from '../../../../../Component/Common/Components/Loading/IntermediateGlobalLoading';
import { PlatformPeople } from '../../../../../Component/Model/Dto/Platform/PlatformPeople';
import { getIOptionsArray } from '../../../../../Helpers/arrayHelper';
import { defaultObject } from '../../../../../Helpers/typescriptHelper';
import { TabPanel } from '../../../../Base/Account/Account';
import { PlatformPeopleEmploymentDataPage } from '../../PeopleEmploymentDataPage';
import { PlatformSalaryDataPage } from '../../Salary/PlatformSalaryDataPage';
import { EditPersonalInformation } from './EditPersonalInformation';
import { PlatformPeopleSalaryEditRole, PlatformPeopleSalaryViewRole, UserAdminRole } from '../../../../../Component/Common/Constants/UserRoles';
import { useRecoilValue } from 'recoil';
import { userRolesState } from '../../../../../State/user.Atom';
import { BreadCrumb } from '../../../../../Component/Common/Components/BreadCrumb/BreadCrumb';
import { OrganisationAtom } from '../../../../../State/Organisation.Atom';

export const EditOrganisationPerson = () => {
    const userRoles = useRecoilValue(userRolesState);
    const [tabValue, setTabValue] = useState<number>(0);
    const { platformPeopleId } = useParams<{ platformPeopleId: string }>();
    const [personData, setPersonData] = useState<PlatformPeople>(defaultObject);
    const [nationalityOptions, setNationalityOptions] = React.useState<IDropDownOptions[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const fetchPersonInformation = async () => {
        try {
            setLoading(true);
            const result = await PlatformPeopleService.getById(platformPeopleId);
            if (result.data) {
                setPersonData(result.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const fetchNationalityData = async () => {
        try {
            const result = await CoreStaticDataService.getNationalities();
            if (result.data) {
                setNationalityOptions(getIOptionsArray(result.data, "id", "name"));
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchData = async () => {
        setLoading(true);
        const personPromise = fetchPersonInformation();
        const nationalityPromise = fetchNationalityData();
        await Promise.all([personPromise, nationalityPromise]);
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, [platformPeopleId])

    if (loading) return (
        <IntermediateGlobalLoading />
    )

    return (
        <>
            <BreadCrumb
                titles={['Manage People', 'Person']}
                hrefs={[`/organisation/people`, '']}
                currentLinkIndex={1}
            />

            <Grid container>
                <Typography variant='h4' sx={{ pb: 2 }}>Person - {personData.fullName}</Typography>
                <Grid item xs={12}>
                    <Tabs value={tabValue} aria-label="Tabs" centered onChange={handleChange}>
                        <Tab label="Personal Information" value={0} />
                        <Tab label="Employment Data" value={1} />
                        {(userRoles.includes(PlatformPeopleSalaryEditRole) ||
                            userRoles.includes(PlatformPeopleSalaryViewRole) ||
                            userRoles.includes(UserAdminRole)) &&
                            <Tab label="Salaries" value={2} />
                        }

                    </Tabs>
                    <TabPanel value={tabValue} index={0}>
                        <EditPersonalInformation
                            nationalityOptions={nationalityOptions}
                            personData={personData}
                            personId={platformPeopleId}
                        />

                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <PlatformPeopleEmploymentDataPage />
                    </TabPanel>
                    {(userRoles.includes(PlatformPeopleSalaryEditRole) ||
                        userRoles.includes(PlatformPeopleSalaryViewRole) ||
                        userRoles.includes(UserAdminRole)) &&
                        <TabPanel value={tabValue} index={2}>
                            <PlatformSalaryDataPage personId={platformPeopleId} personFullName={personData.fullName} />
                        </TabPanel>
                    }
                </Grid>
            </Grid>
        </>
    )
}

